import AddUploadButton from 'components/ui/general/buttons/AddUploadButton'
import React, { useEffect, useRef, useState } from 'react'
import './FilesContent.scss'
import FolderDisplay from 'components/ui/dataDisplay/FolderDisplay'
import { useListFileType } from 'graphQLHooks/dataManager/dataManagerHooks'
import { cloneDeep, flatten, get, isArray, isEmpty, set, uniqBy } from 'lodash'
import {
  useCreateFolder,
  useCreateFile,
  useDeleteFolder,
  useGetUploadURL,
  useListFolders,
  useListFiles,
  useUpdateFolder
} from 'graphQLHooks/content/contentHooks'
import { utilityService } from 'services/UtilityService'
import FilterInput from 'components/ui/dataEntry/inputs/FilterInput'
import { Col, Empty, message, Row } from 'antd'
import UploadQueueModal from 'components/ui/feedback/UploadQueueModal'
import { IMAGE_UPLOAD_MODES } from 'constants/general-constants'
import ApiService from 'services/ApiService'
import InfiniteScroll from 'react-infinite-scroller'
import FileItemDisplay from 'components/ui/dataDisplay/FileItemDisplay'
import LoadingButton from 'components/ui/general/buttons/LoadingButton'
import EditFolderModal from 'components/ui/dataEntry/other/EditFolderModal'
import QueryListFiles from 'graphQL/content/listFiles'
import ImageLoadingDisplay from 'components/ui/dataDisplay/ImageLoadingDisplay'
import QueryListFolders from 'graphQL/content/listFolders'
import ImageLoadingSkeleton from './ImageLoadingSkeleton'
import ContentDetails from './ContentDetails'
import { Menu, Item, contextMenu } from 'react-contexify'
import DeleteFolderModal from 'components/ui/dataEntry/other/DeleteFolderModal'
import { findFileExtension } from '../../util/util'
import userMessages from 'constants/messages'

const DUMMY_BREAD_CRUMB = [
  {
    type: 'folder',
    name: 'Root Folder',
    root: true
  }
]

const removeBInaryFromFileList = files => {
  const binaryRemovedFileList = cloneDeep(files).map(fileItem => {
    const { fileBinary, progress, ...others } = fileItem
    return {
      ...others
    }
  })
  return binaryRemovedFileList
}

const LEVEL_TYPES = {
  LEVEL_1: 'LEVEL_1',
  LEVEL_2: 'LEVEL_2'
}

const getFIlterMediaVariables = (project) => {
  const variables = utilityService.getFormattedMediaFilter(
    '',
    {
      isArchived: {
        match: false
      }
    },
    undefined,
    project
  )
  return variables
}

// generateSingleRowClass(innerFolderList, fileList)

const generateSingleRowClass = (innerFolderList, fileList) => {
  const innerFolderListLength = innerFolderList?.length || 0
  const fileListLength = fileList?.length || 0
  const totalLength = innerFolderListLength + fileListLength
  return totalLength <= 4
}

const afterFileEditCallback = (cache, updateMedia, useListFilesVariables) => {
  console.log('afterFileEditCallback')
  const existingList = cache.readQuery({
    query: QueryListFiles,
    variables: useListFilesVariables
  })
  const copyOfExistingList = cloneDeep(existingList?.listFiles?.items || [])
  if (!isEmpty(existingList?.listFiles?.items) && !isEmpty(updateMedia)) {
    copyOfExistingList.forEach(item => {
      if (item.id === updateMedia?.id) {
        item = updateMedia
      }
    })
    cache.writeQuery({
      query: QueryListFiles,
      variables: useListFilesVariables,
      data: {
        copyOfExistingList
      }
    })
  }
}

// when archived file is restored
const afterRestoreFileCallback = (cache, restoredFile, useListFilesVariables) => {
  const existingList = cache.readQuery({
    query: QueryListFiles,
    variables: useListFilesVariables
  })
  const copyOfExistingList = cloneDeep(existingList?.listFiles?.items || [])
  if (!isEmpty(existingList?.listFiles?.items) && !isEmpty(restoredFile)) {
    const newList = copyOfExistingList.filter(item => item.id !== restoredFile.id)
    cache.writeQuery({
      query: QueryListFiles,
      variables: useListFilesVariables,
      data: {
        listFiles: {
          ...existingList?.listFiles,
          items: newList
        }
      }
    })
  }
}

// when file is archived
const afterDeleteMediaCallback = (cache, updateMedia, useListFilesVariables) => {
  const existingList = cache.readQuery({
    query: QueryListFiles,
    variables: useListFilesVariables
  })
  const copyOfExistingList = cloneDeep(existingList?.listFiles?.items || [])
  if (!isEmpty(existingList?.listFiles?.items) && !isEmpty(updateMedia)) {
    const newList = copyOfExistingList.filter(item => item.id !== updateMedia.id)
    cache.writeQuery({
      query: QueryListFiles,
      variables: useListFilesVariables,
      data: {
        listFiles: {
          ...existingList?.listFiles,
          items: newList
        }
      }
    })
  }
}

const getRowSizes = (showFileDetailsSideBar, enableFolderCreation) => {
  const rowsSizes = {
    // main content row sizes
    contentSize: 18,
    sidebarSize: 6,
    // filter row columns sizes
    filterButtonWrapperSize: 4,
    filterSize: 20
  }
  if (!showFileDetailsSideBar) {
    rowsSizes.contentSize = 24
    rowsSizes.sidebarSize = 0
  }
  if (!enableFolderCreation) {
    rowsSizes.filterSize = 24
    rowsSizes.filterButtonWrapperSize = 0
  }
  return rowsSizes
}

const FilesContent = ({
  project,
  radio = null,
  enableUpload = true,
  showFileDetailsSideBar = true,
  enableFolderActions = true,
  enableFolderCreation = true,
  onItemSelect = () => null,
  rootFolderItemsToShow,
  className = ''
}) => {
  const isUsedFromAssetManager = !isEmpty(rootFolderItemsToShow)
  // const client = useApolloClient()
  const breadcrumbsRef = useRef(null)
  const [rootFolderDetails, setRootFolderDetails] = useState({})
  const [innerFolderDetails, setInnerFolderDetails] = useState(null)
  const [selectedFile, setSelectedFile] = useState(null)
  const [selectedFolder, setSelectedFolder] = useState(null)
  const [selectedItemId, setSelectedItemId] = useState(null)
  const [isDeleteFolderModalOpen, setIsDeleteFolderModalOpen] = useState(false)
  const [isEditFolderModelOpen, setEditFolderModalOpen] = useState(false)
  const [isCreateFolderModalOpen, setCreateFolderModalOpen] = useState(false)
  const [deleteFolderItem, setDeleteFolderItem] = useState(null)
  const [editFolderInfo, setEditFolderInfo] = useState(null)
  const [hasMoreFoldersToLoad, setHasMoreFoldersToLoad] = useState(true)
  const [hasMoreFilesToLoad, setHasMoreFilesToLoad] = useState(false)
  const [filterContent, setFilterContent] = useState(null)
  const [searchString, setSearchString] = useState('')
  const [filesGettingUploaded, setFilesGettingUploaded] = useState([])
  const [newFolderTagSearchKey, setNewFolderTagSearchKey] = useState(false)
  const [breadCrumbData, setBreadCrumbData] = useState(DUMMY_BREAD_CRUMB)
  // const [files, setFiles] = useState([])
  const selectItemHandler = (fileItem, folderItem) => {
    // if one is selected other will be nullified
    if (fileItem) {
      setSelectedFile(fileItem)
      setSelectedItemId(fileItem?.id)
      onItemSelect(fileItem)
    }
    if (folderItem) {
      setSelectedFolder(folderItem)
      setSelectedItemId(folderItem?.id)
      onItemSelect(folderItem)
    }
  }
  // const [selectedItem, setSelectedItem] = useState(null)
  const [rootFolderFilesMode, setRootFolderFilesMode] = useState(true)
  const [fileUploadModalOpen, setFileUploadModalOpen] = useState(false)
  const resetLoadState = () => {
    setHasMoreFoldersToLoad(true)
    setHasMoreFilesToLoad(false)
  }
  const handleFileUploadModal = flag => setFileUploadModalOpen(flag)
  const filesTabUploadHandler = async (fileList = [], uploadType, tagsFromUploadModal) => {
    // const isLotteFileUpload = utilityService.toLowerCaseAndReplaceSpaces(uploadType) === utilityService.toLowerCaseAndReplaceSpaces(UPLOAD_OPTION_TYPES.LOTTIE)
    // const isJsonFileUpload = utilityService.toLowerCaseAndReplaceSpaces(uploadType) === utilityService.toLowerCaseAndReplaceSpaces(UPLOAD_OPTION_TYPES.JSON)
    // const isPDFFileUpload = utilityService.toLowerCaseAndReplaceSpaces(uploadType) === utilityService.toLowerCaseAndReplaceSpaces(UPLOAD_OPTION_TYPES.PDF)
    // const isSVGFileUpload = utilityService.toLowerCaseAndReplaceSpaces(uploadType) === utilityService.toLowerCaseAndReplaceSpaces(UPLOAD_OPTION_TYPES.SVG)
    const fileListForAPI = fileList.map(uploadFileItem => {
      return {
        fileName: uploadFileItem.name,
        contentType: uploadFileItem.type,
        type: uploadType,
        fileBinary: uploadFileItem,
        progress: 0
      }
    })

    setFilesGettingUploaded(fileListForAPI)
    handleFileUploadModal(false)

    // calling api in event as running it on useeffect was causing multiple creatmedia call issue
    const uploadURL = await getUploadURL({
      variables: {
        project,
        files: (() => {
          const data = removeBInaryFromFileList(fileListForAPI)
          return data
        })()
      }
    })
    const urlUploadData = uploadURL?.data?.getUploadUrl
    let filesGettingUploaded = cloneDeep(fileListForAPI)
    if (!isEmpty(urlUploadData)) {
      const promiseArrayUploadFunctions = urlUploadData.map((fileUploadUrl, index) => {
        const isLastItem = index === (urlUploadData.length - 1)
        const { key, uploadUrl } = fileUploadUrl
        const fileItem = filesGettingUploaded[index]
        const fileName = fileItem.fileName
        return (updatedFiles) => {
          return new Promise((resolve, reject) => {
            ApiService(
              'PUT',
              uploadUrl,
              fileItem.fileBinary,
              { 'Content-Type': fileItem.contentType },
              () => {
                let tagsToSent = rootFolderFilesMode
                  ? []
                  : innerFolderDetails?.tags?.map(item => item.key) || []
                if (!isEmpty(tagsFromUploadModal) && isArray(tagsFromUploadModal)) {
                  tagsToSent = [...tagsToSent, ...tagsFromUploadModal]
                }
                createFile({
                  variables: {
                    name: fileName,
                    tags: tagsToSent,
                    project,
                    key,
                    type: rootFolderDetails.key,
                    mediaType: 'FILE'
                  },
                  onCompleted: (createMediaResponse) => {
                    message.success(userMessages.FILE_UPLOAD_SUCCESS)
                    const filteredArray = filesGettingUploaded.filter(fileItem => fileItem.fileBinary.name !== fileName)
                    filesGettingUploaded = filteredArray
                    resolve({
                      fileItem: fileItem,
                      success: true,
                      createMediaResponse: createMediaResponse,
                      newFilesGettingUploaded: filteredArray
                    })

                    // set last file as selected
                    if (isLastItem) {
                      // setSelectedItem(createMediaResponse?.createFile)
                      // setSelectedFile(createMediaResponse?.createFile)
                      selectItemHandler(createMediaResponse?.createFile)
                    }
                  },
                  onError: (error) => {
                    utilityService.handleError(error)
                    reject(error)
                  },
                  update: (proxy, { data: { createFile } }) => {
                    const existingList = proxy.readQuery({
                      query: QueryListFiles,
                      variables: useListFilesVariables
                    })
                    const isFreshUpload = isEmpty(existingList?.listFiles)
                    let listFiles = null
                    if (isFreshUpload) {
                      listFiles = {
                        totalCount: 1,
                        items: [createFile]
                      }
                    } else {
                      listFiles = {
                        ...existingList.listFiles,
                        totalCount: existingList?.listFiles?.totalCount + 1,
                        items: [createFile, ...existingList.listFiles.items]
                      }
                    }
                    if (!isEmpty(existingList?.listFiles)) {
                      proxy.writeQuery({
                        query: QueryListFiles,
                        variables: useListFilesVariables,
                        data: {
                          listFiles
                        }
                      })
                    }
                  }
                  // optimisticResponse: (vars, { IGNORE }) => {
                  //   return {
                  //     __typename: 'Mutation',
                  //     createFile: {
                  //       'id': '123123ee835c4f-24ea-32aa-9988-1ded695a2ba1235',
                  //       'fileName': 'https://vcms-storage-stack-dev-mediafilestorage-rcef10ph7jid.s3.amazonaws.com/767fd114-f3fd-4548-b166-68669d7ec314_lottie-lego.lottie',
                  //       'createdAt': '2025-02-21T13:42:06.909Z',
                  //       'name': 'wow--Lottie Lego.lottie'
                  //     }
                  //   }
                  // },
                })
              },
              error => {
                // failureCallBack
                console.log('error', error)
              },
              progress => {
                // progressCallBack
                const updatedFileProgressArray = cloneDeep(updatedFiles)
                updatedFileProgressArray.forEach(fileItem => {
                  if (fileItem.fileBinary.name === fileName) {
                    fileItem.percentage = progress
                  }
                })
                setFilesGettingUploaded(updatedFileProgressArray)
              }
            )
          })
        }
      })
      // run uploads sequentially, finish one first then start next one
      for (const uploadFunction of promiseArrayUploadFunctions) {
        const { newFilesGettingUploaded } = await uploadFunction(filesGettingUploaded)
        filesGettingUploaded = newFilesGettingUploaded
        setFilesGettingUploaded(filesGettingUploaded)
      }
    }
  }
  const getAcceptFileTypeExtensions = extensionValue => {
    const extension = utilityService.toLowerCaseAndReplaceSpaces(extensionValue)
    return `.${extension}`
  }
  const loadContentBasedOnFilterHandler = (level, filterOptions) => {
    const { folderId, tags, customFilterContent } = filterOptions
    let filterContent = {}
    const isArchivedFilter = customFilterContent?.isArchived
    const multipleExactFilter = customFilterContent?.tags?.multiple_exact
    const userFilter = customFilterContent?.createdBy
    const createdAtFilter = customFilterContent?.createdAt
    if (level === LEVEL_TYPES.LEVEL_1) {
      filterContent = {
        isArchived: {
          match: false
        },
        type: {
          match: folderId
        }
      }
      // isArchivedFilter, multipleExactFilter, userFilter, createdAtFilter are set when filter input is changed, if they are set also include them when navigating inside root folder
      if (!isEmpty(multipleExactFilter)) {
        set(filterContent, 'tags.multiple_exact', multipleExactFilter)
      }
      if (!isEmpty(userFilter)) {
        set(filterContent, 'createdBy', userFilter)
      }
      if (!isEmpty(createdAtFilter)) {
        set(filterContent, 'createdAt', createdAtFilter)
      }
      if (!isEmpty(isArchivedFilter)) {
        set(filterContent, 'isArchived', isArchivedFilter)
      }
    }
    if (level === LEVEL_TYPES.LEVEL_2) {
      const tagNameArray = tags?.map(tagItem => tagItem.key) || null
      filterContent = {
        isArchived: {
          match: false
        },
        type: {
          match: folderId
        },
        tags: {
          multiple_precise: tagNameArray
        }
      }

      // isArchivedFilter, multipleExactFilter, userFilter, createdAtFilter are set when filter input is changed, if they are set also include them when navigating inside an inner folder present inside a root folder
      if (!isEmpty(multipleExactFilter)) {
        set(filterContent, 'tags.multiple_exact', multipleExactFilter)
      }
      if (!isEmpty(userFilter)) {
        set(filterContent, 'createdBy', userFilter)
      }
      if (!isEmpty(createdAtFilter)) {
        set(filterContent, 'createdAt', createdAtFilter)
      }
      if (!isEmpty(isArchivedFilter)) {
        set(filterContent, 'isArchived', isArchivedFilter)
      }
    }
    return filterContent
  }

  const getForwardBreadCrumbData = (breadCrumbData, folderItem) => {
    const existingBreadCrumbData = cloneDeep(breadCrumbData)
    const navigateForwardPath = breadcrumbsRef.current?.navigateForwardPath
    const existingData = get(existingBreadCrumbData, navigateForwardPath)
    set(existingBreadCrumbData, navigateForwardPath, { ...existingData, children: [folderItem] })
    return existingBreadCrumbData
  }

  // this will list root folders
  const {
    data: folderListData,
    loading: isFileListLoading
    // refetch: refetchFileList
  } = useListFileType({
    variables: {
      module: '',
      project,
      limit: 999,
      nextToken: ''
    }
  })

  // this will list inner folders inside a folder in root ( eg: folders inside lotte folder in root )
  const [useListFoldersVariables, setUseListFoldersVariables] = useState({
    limit: 20,
    offset: 0,
    orderBy: 'name',
    order: 'asc',
    project,
    filter: {
      type: {
        exact: ''
      }
    }
  })
  const {
    data: innerFolderListData,
    loading: isInnerFolderListDataLoading,
    fetchMore: fetchMoreFolders
  } = useListFolders({
    variables: useListFoldersVariables,
    fetchPolicy: 'network-only',
    skip: isEmpty(useListFoldersVariables?.filter?.type?.exact),
    notifyOnNetworkStatusChange: true,
    // prevent refetch when cache is updated, when recalling this api after new folder is created
    nextFetchPolicy: 'cache-only'
  })

  // this will list files inside folder
  // const [useListFilesVariables, setUseListFilesVariables] = useState(getFIlterMediaVariables(project))
  const [customFilterContent, setCustomFilterContent] = useState({})
  const [useListFilesVariables, setUseListFilesVariables] = useState(getFIlterMediaVariables(project))
  const {
    data: fileListData,
    loading: isFileListDataLoading,
    fetchMore: fetchMoreFiles
  } = useListFiles({
    variables: useListFilesVariables,
    fetchPolicy: 'network-only',
    skip: hasMoreFoldersToLoad,
    notifyOnNetworkStatusChange: true
  })

  const [ getUploadURL ] = useGetUploadURL({ fetchPolicy: 'network-only' })
  const [
    createFile
    // {
    //   loading: isCreateMediaLoading
    // }
  ] = useCreateFile()

  const [createFolder, { loading: isCreateMediaLoading }] = useCreateFolder()
  const [updateFolder, { loading: isUpdateFolderLoading }] = useUpdateFolder()
  const [deleteFolder, { loading: isDeleteFolderLoading }] = useDeleteFolder()

  const folderList = folderListData?.listFileType?.items || []
  const fileList = fileListData?.listFiles?.items || []
  const innerFolderList = innerFolderListData?.listFolders?.items || []
  // console.log('selectedItem', selectedItem)
  const isFileSelected = Boolean(selectedFile?.fileName)
  const getFormattedFilter = (filterVal) => {
    const filterData = typeof (filterVal) === 'string' ? filterVal.split(',') : filterVal
    let value = (filterData || []).map((innerItem) => innerItem.key)
    value = value && value.length ? value : null
    return value
  }

  const getNewFilterVariables = (filter, filterContent) => {
    let newFilter = cloneDeep(filterContent)
    let isClearFilterClicked = true
    if (!isEmpty(filter)) {
      filter.forEach((filterItem) => {
        const filterValue = filterItem.value
        if (!filterValue) return
        isClearFilterClicked = false
        const filterKeyName = filterItem?.name
        const filterType = filterItem?.type
        if (filterType === 'KEYWORD') {
          set(newFilter, `${filterKeyName}.multiple_exact`, getFormattedFilter(filterValue))
        } else if (filterType === 'DATE') {
          set(newFilter, `${filterKeyName}.multiple_exact`, filterValue?.split(','))
        } else if (filterKeyName === 'isArchived') {
          set(newFilter, `${filterKeyName}.match`, filterValue)
        }
      })
    }
    // when user tries to clear filter from any folder inside root folder, generate filter corresponding to that folder and update state
    if (isClearFilterClicked) {
      const filterContent = loadContentBasedOnFilterHandler(LEVEL_TYPES.LEVEL_2, {
        folderId: rootFolderDetails?.id,
        tags: selectedFolder.tags,
        customFilterContent: {}
      })
      newFilter = filterContent
    }
    return newFilter
  }

  useEffect(() => {
    if (isArray(innerFolderListData?.listFolders?.items)) {
      const hasMoreFoldersToLoad = innerFolderListData?.listFolders?.items?.length < innerFolderListData?.listFolders?.totalCount
      setHasMoreFoldersToLoad(hasMoreFoldersToLoad)
    }
  }, [innerFolderListData, breadCrumbData])

  useEffect(() => {
    if (isArray(fileListData?.listFiles?.items)) {
      let hasMoreFilesToLoad = fileListData?.listFiles?.items.length < fileListData?.listFiles?.totalCount
      setHasMoreFilesToLoad(hasMoreFilesToLoad)
    }
  }, [fileListData, breadCrumbData])

  useEffect(() => {
    if (isEmpty(folderList)) return
    const firstItem = folderList[0]
    // setSelectedItem(firstItem)
    // setSelectedFile(firstItem)
    selectItemHandler(firstItem)
  }, [folderList])

  const renderRootFolders = (folderList) => {
    let isAllItemsDisabled = true
    const rootFolders = folderList.map(folderItem => {
      const id = folderItem.id
      // if rootFolderItemsToShow has data show only those folders, else show all folders
      if (isUsedFromAssetManager) {
        if (!rootFolderItemsToShow.includes(folderItem.key)) return null
      }
      if (!folderItem.isEnabled) return null
      isAllItemsDisabled = false
      return (
        <FolderDisplay
          key={id}
          folderIndex={id}
          selected={selectedItemId === id}
          fileName={folderItem.name}
          onSelect={() => {
            // setSelectedFolder(folderItem)
            selectItemHandler(null, folderItem)
            // setSelectedItem(folderItem)
            setRootFolderDetails(folderItem)
          }}
          onDoubleClick={() => {
            if (rootFolderFilesMode) {
              setRootFolderFilesMode(false)
            }
            const newBreadCrumbData = getForwardBreadCrumbData(breadCrumbData, {
              // id: folderItem.id,
              // name: folderItem.name,
              ...folderItem
            })
            setBreadCrumbData(newBreadCrumbData)

            // fetch and list new files inside this folder
            const filterContent = loadContentBasedOnFilterHandler(LEVEL_TYPES.LEVEL_1, {
              folderId: id,
              customFilterContent
            })
            setFilterContent(filterContent)
            // console.log('filterContent', filterContent)
            // console.log('useListFilesVariables', useListFilesVariables)
            const variables = utilityService.getFormattedMediaFilter(
              searchString,
              filterContent,
              undefined,
              project
            )
            // variables.limit = 1
            setUseListFilesVariables(variables)

            // fetch and list folders inside this folder
            setUseListFoldersVariables(prevVariables => {
              return {
                ...prevVariables,
                filter: {
                  type: {
                    exact: folderItem.id
                  }
                }
              }
            })
          }}
        />
      )
    })
    return {
      rootFolders,
      isAllItemsDisabled
    }
  }
  const { rootFolders, isAllItemsDisabled } = renderRootFolders(folderList)
  const renderContentDetailsSidebar = (sidebarSize) => {
    const selectedItem = selectedFile || selectedFolder
    const contentDetailsSidebar = (
      <Col sm={sidebarSize} className='content-details-container' >
        {/* <p>selectedFolder :: <pre>{JSON.stringify(selectedFolder, null, 2)}</pre></p> */}
        {/* style={{ display: 'flex', border: '1px solid red' }} */}
        {/* <p>selectedFile :: <pre>{JSON.stringify(selectedFile, null, 2)}</pre></p>
        <p>selectedItem :: <pre>{JSON.stringify(selectedItem, null, 2)}</pre></p> */}
        {/* {console.log('useListFilesVariables', useListFilesVariables)} */}
        {/* <p>QueryListFiles :: <pre>{JSON.stringify(useListFilesVariables, null, 1)}</pre></p>
        <p>filterContent :: <pre>{JSON.stringify(filterContent, null, 1)}</pre></p> */}
        {/* <button
          onClick={() => {
            const existingList = client.cache.readQuery({
              query: QueryListFiles,
              variables: useListFilesVariables
            })
            console.log('existingList', existingList)
          }}
        >cache</button> */}
        <ContentDetails
          mode={IMAGE_UPLOAD_MODES.FILES_MODE}
          appliedFilter={{
            searchString
          }}
          selectedMedia={selectedItem?.id}
          onDeleteMedia={(id) => {
            console.log('id', id)
          }}
          isFolder={!isFileSelected}
          folderData={selectedItem}
          project={project}
          selectedFileType={isFileSelected
            ? utilityService.toLowerCaseAndReplaceSpaces(findFileExtension(selectedItem.name, false))
            : 'folder'
          }
          mediaDetails={selectedItem}
          afterFileEditCallback={(cache, updateMedia) => afterFileEditCallback(cache, updateMedia, useListFilesVariables)}
          afterDeleteMediaCallback={(cache, updateMedia) => afterDeleteMediaCallback(cache, updateMedia, useListFilesVariables)}
          afterRestoreFileCallback={(cache, updateMedia) => afterRestoreFileCallback(cache, updateMedia, useListFilesVariables)}
        // isSaving={shouldRefreshHistory}
        />
      </Col>
    )
    return contentDetailsSidebar
  }
  const { contentSize, sidebarSize, filterSize, filterButtonWrapperSize } = getRowSizes(showFileDetailsSideBar, enableFolderCreation)
  return (
    <>
      <Col md={contentSize} className={`content-list-container ${className}`}>
        {radio}
        <div className='files-content'>
          {!rootFolderFilesMode && (
            <Row
              gutter={[20]}
              className='filter-wrapper'
            >
              <Col sm={filterSize} id='search-filter-container'>
                <FilterInput
                  filterType='ContentBankFiles'
                  onChangeSearchInput={(searchString) => {
                    setSearchString(searchString)
                    const variables = utilityService.getFormattedMediaFilter(
                      searchString,
                      filterContent,
                      undefined,
                      project
                    )
                    setUseListFilesVariables(variables)
                  }}
                  searchString={searchString}
                  placement='bottomRight'
                  changeFilter={(filter) => {
                    const newFilter = getNewFilterVariables(filter, filterContent)
                    setUseListFilesVariables(prevState => {
                      return {
                        ...prevState,
                        filter: newFilter
                      }
                    })
                    setCustomFilterContent(newFilter)
                  }}
                  isClearFilter={false}
                  parentId='search-filter-container'
                  project={project}
                  clearSearch={() => {
                    setUseListFilesVariables(prevState => {
                      return {
                        ...prevState,
                        filter: filterContent
                      }
                    })
                    setCustomFilterContent({})
                  }}
                />
              </Col>
              {
                enableFolderCreation &&
                  <Col sm={filterButtonWrapperSize}>
                    <LoadingButton
                      buttonText='Create Folder'
                      onClick={() => {
                        setCreateFolderModalOpen(true)
                      }}
                      buttonClass='create-folder-button'
                      isDisabled={isInnerFolderListDataLoading || isCreateMediaLoading}
                    />
                  </Col>
              }
            </Row>
          )}
          {/* Generate bread crumbs */}
          {(() => {
            let currentPath = {
              navigateForwardPath: ''
            }
            const arrayOfElements = []
            const recursiveBreadCrumbMaker = (breadCrumbDataArray, index) => {
              if (index || index === 0) {
                currentPath.navigateForwardPath = `${currentPath.navigateForwardPath}.children.[${index}]`
              } else {
                currentPath.navigateForwardPath = '[0]'
              }
              breadcrumbsRef.current = currentPath
              breadCrumbDataArray.forEach((item, index) => {
                const isRootElement = item.root
                const hasNoChildren = isEmpty(item?.children)
                arrayOfElements.push(
                      <>
                        <button
                          disabled={hasNoChildren}
                          onClick={e => {
                            const getBackwardBreadCrumbData = breadCrumbData => {
                              const currentPath = e.target.getAttribute('data-currentPath')
                              const newData = cloneDeep(breadCrumbData)
                              set(newData, `${currentPath}.children`, null)
                              return newData
                            }
                            const newBreadCrumbData = getBackwardBreadCrumbData(breadCrumbData)
                            setBreadCrumbData(newBreadCrumbData)
                            if (isRootElement) {
                              console.log('item', item)
                              setRootFolderFilesMode(true)
                              resetLoadState()
                              setCustomFilterContent({})
                            } else {
                              // fetch and list new files inside this folder
                              const filterContent = loadContentBasedOnFilterHandler(LEVEL_TYPES.LEVEL_1, {
                                folderId: item.id,
                                customFilterContent
                              })
                              setFilterContent(filterContent)
                              const variables = utilityService.getFormattedMediaFilter(
                                searchString,
                                filterContent,
                                undefined,
                                project
                              )
                              setUseListFilesVariables(variables)

                              // fetch and list folders inside this folder
                              setUseListFoldersVariables(prevVariables => {
                                return {
                                  ...prevVariables,
                                  filter: {
                                    type: {
                                      exact: item.id
                                    }
                                  }
                                }
                              })

                              // setSelectedItem(item)
                              // setSelectedFolder(item.children?.[0])
                              selectItemHandler(null, item.children?.[0])

                              // client.cache
                            }
                          }}
                          className={`
                            breadcrumbs-folder 
                            ${isRootElement ? 'breadcrumbs-parent' : ''}`
                          }
                          data-currentPath={currentPath.navigateForwardPath}>
                          {` ${item.name} `}
                          {/* <p style={{ fontSize: '10px' }}> {currentPath.navigateForwardPath} </p> */}
                        </button>
                        {!hasNoChildren && <p className='breadcrumbs-division'> / </p>}
                      </>
                )
                if (!isEmpty(item.children)) {
                  recursiveBreadCrumbMaker(item.children, index)
                }
              })
            }
            recursiveBreadCrumbMaker(breadCrumbData)
            const elements = arrayOfElements.map(item => {
              return item
            })
            return (
              <Row gutter={[20]}>
                <Col xs={24}>
                  <div
                    className='files-tab-breadcrumbs'
                    data-navigateForwardPath={currentPath.navigateForwardPath}
                    data-navigateBackWardPath={currentPath.navigateBackWardPath}
                  >
                    {elements}
                  </div>
                </Col>
              </Row>
            )
          })()}
          {rootFolderFilesMode ? (
            <>
              {
                isFileListLoading
                  ? (
                    <div className='file-items'>
                      {
                        [...Array(20)].map((_, index) => <ImageLoadingSkeleton key={index} />)
                      }
                    </div>
                  )
                  : <>
                    {
                      (isEmpty(folderList) || isAllItemsDisabled)
                        ? <div className='file-items-wrapper empty-thumbnail'><Empty /></div>
                        : (
                          <div
                            className={`
                            file-items 
                            ${(folderList.length <= 4 || isUsedFromAssetManager) ? 'single-row' : ''}
                          `}>
                            {rootFolders}
                          </div>
                        )
                    }
                </>
              }
            </>
          ) : (
            <div className='file-items-wrapper'>
              <InfiniteScroll
                initialLoad={false}
                loadMore={() => {
                  const existingVariables = cloneDeep(useListFoldersVariables)
                  existingVariables.offset = innerFolderList.length
                  if (hasMoreFoldersToLoad) {
                    fetchMoreFolders({
                      variables: existingVariables,
                      updateQuery: (previousData, { fetchMoreResult }) => {
                        const previousFolderItems = previousData?.listFolders?.items || []
                        const newFolderItems = fetchMoreResult.listFolders.items
                        const uniqueItems = uniqBy(flatten([previousFolderItems, newFolderItems]), 'name')
                        return {
                          ...previousData,
                          listFolders: {
                            ...(previousData?.listFolders || []),
                            items: uniqueItems
                          }
                        }
                      }
                    })
                  }

                  // only lazy load  file list if full folders are loaded
                  if (!hasMoreFoldersToLoad) {
                    const existingVariables = cloneDeep(useListFilesVariables)
                    existingVariables.offset = fileList.length
                    fetchMoreFiles({
                      variables: existingVariables,
                      updateQuery: (previousData, { fetchMoreResult }) => {
                        const previousFileItems = previousData?.listFiles?.items || []
                        const newFileItems = fetchMoreResult?.listFiles?.items || []
                        const uniqueItems = uniqBy(flatten([previousFileItems, newFileItems]), 'id')
                        return {
                          ...previousData,
                          listFiles: {
                            ...(previousData?.listFiles || []),
                            items: uniqueItems
                          }
                        }
                      }
                    })
                  }
                }}
                hasMore={hasMoreFoldersToLoad || hasMoreFilesToLoad}
                useWindow={false}
                // initialLoad={false}
                className={`
                  file-items-container
                  ${generateSingleRowClass(innerFolderList, fileList) ? 'single-row' : ''}
                `}
                loader={null}
              >

                {
                  enableUpload &&
                  <AddUploadButton
                    onClick={() => {
                      handleFileUploadModal(true)
                    }}
                  />

                }

                {/* -----------------------  LISTING ALL INNER FOLDERS starts ----------------------- */}
                {innerFolderList.map((innerFolder, index) => {
                  const id = innerFolder?.id
                  return (
                    <div
                      onContextMenu={(e) => {
                        contextMenu.show({
                          id: id,
                          event: e
                        })
                      }}
                    >
                      <FolderDisplay
                        key={id}
                        folderIndex={innerFolder.id}
                        selected={selectedItemId === id}
                        fileName={innerFolder.name}
                        onSelect={() => {
                          // setSelectedItem(innerFolder)
                          // setSelectedFolder(innerFolder)
                          selectItemHandler(null, innerFolder)
                        }}
                        onDoubleClick={() => {
                          const newBreadCrumbData = getForwardBreadCrumbData(breadCrumbData, {
                            isInnerFolder: true,
                            ...innerFolder
                          })
                          setBreadCrumbData(newBreadCrumbData)

                          // setSelectedInnerFolderItem(innerFolder)
                          // setSelectedItem(innerFolder)
                          // setSelectedFolder(innerFolder)
                          selectItemHandler(null, innerFolder)

                          // fetch and list new files inside this folder
                          const filterContent = loadContentBasedOnFilterHandler(LEVEL_TYPES.LEVEL_2, {
                            folderId: rootFolderDetails?.id,
                            tags: innerFolder.tags,
                            customFilterContent
                          })
                          setFilterContent(filterContent)
                          const variables = utilityService.getFormattedMediaFilter(
                            searchString,
                            filterContent,
                            undefined,
                            project
                          )
                          setUseListFilesVariables(variables)

                          // this will simulate a fake api call with fake id with no data so folder list will be cleared when double clicking inner folders
                          setUseListFoldersVariables(prevVariables => {
                            return {
                              ...prevVariables,
                              filter: {
                                type: {
                                  exact: innerFolder.id
                                }
                              }
                            }
                          })
                          setInnerFolderDetails(innerFolder)
                        }}
                      />
                      <Menu id={id}>
                        <Item
                          onClick={() => {
                            setEditFolderInfo(innerFolder)
                            setEditFolderModalOpen(true)
                          }}
                        >
                          Edit
                        </Item>
                        <Item
                          onClick={() => {
                            if (isDeleteFolderLoading) {
                              message.error(userMessages.FOLDER_DELETE_ON_PROGRESS_ACTION)
                              return
                            }
                            setDeleteFolderItem(innerFolder)
                            setIsDeleteFolderModalOpen(true)
                          }}
                        >
                          Delete
                        </Item>
                      </Menu>
                    </div>
                  )
                })}
                {/* -----------------------  LISTING ALL INNER FOLDERS ends ----------------------- */}

                {/* -----------------------  LISTING ALL INNER FILES starts ----------------------- */}
                {filesGettingUploaded.map(uploadingFile => {
                  return (
                    <ImageLoadingDisplay
                      name={uploadingFile.fileName}
                      percentage={uploadingFile.percentage || 0}
                    />
                  )
                })}
                {fileList.map(fileItem => {
                  const type = utilityService.toLowerCaseAndReplaceSpaces(findFileExtension(fileItem.name))
                  return (
                    <FileItemDisplay
                      key={fileItem.id}
                      type={type}
                      url={fileItem.fileName}
                      name={fileItem.name}
                      selected={selectedItemId === fileItem.id}
                      onSelect={() => {
                        // setSelectedItem(fileItem)
                        // setSelectedFile(fileItem)
                        selectItemHandler(fileItem)
                      }}
                    />
                  )
                })}
                {/* -----------------------  LISTING ALL INNER FILES ends ----------------------- */}

                {(isInnerFolderListDataLoading || isFileListDataLoading) &&
                  [...Array(7)].map((item, index) => (
                    <ImageLoadingSkeleton key={index} />
                  ))
                }
              </InfiniteScroll>
            </div>
          )}
        </div>
      </Col>

      {
        showFileDetailsSideBar &&
        renderContentDetailsSidebar(sidebarSize)
      }

      {/* For uploading files */}
      {
        enableUpload &&
        <UploadQueueModal
          visible={fileUploadModalOpen}
          isLocalFolderOpen={false}
          handleCancel={() => {
            handleFileUploadModal(false)
          }}
          uploadList={(fileList, tags) => filesTabUploadHandler(fileList, rootFolderDetails?.id, tags)}
          project={project}
          accept={getAcceptFileTypeExtensions(rootFolderDetails?.extension)}
          uploadType={rootFolderDetails?.extension}
          mode={IMAGE_UPLOAD_MODES.FILES_MODE}
          // selectedFolderExtension={findFileExtension(selectedItem)}
        />
      }

      {/* Create folder modal */}
      {
        enableFolderCreation &&
        <EditFolderModal
          visible={isCreateFolderModalOpen}
          editFolderInfo={[]}
          handleSubmit={input => {
            if (isEmpty(input.name) || isEmpty(input?.tags)) return
            createFolder({
              variables: {
                name: input.name,
                type: rootFolderDetails?.id,
                tags: input.tags,
                project
              },
              onCompleted: () => {
                message.success(userMessages.FOLDER_CREATE_SUCCESS)
              },
              onError: (error) => {
                utilityService.handleError(error)
              },
              update: (cache, newData) => {
                const existingData = cache.readQuery({
                  query: QueryListFolders,
                  variables: useListFoldersVariables
                })
                cache.writeQuery({
                  query: QueryListFolders,
                  variables: useListFoldersVariables,
                  data: {
                    ...existingData,
                    listFolders: {
                      ...existingData.listFolders,
                      items: [
                        newData.data.createFolder,
                        ...existingData.listFolders.items
                      ]
                    }
                  },
                  // prevent refetch when cache is updated
                  broadcast: false
                })
                setCreateFolderModalOpen(false)
              }
            })
          }}
          handleCancel={() => {
            setCreateFolderModalOpen(false)
            setEditFolderInfo(null)
          }}
          loading={isCreateMediaLoading}
          title='CREATE FOLDER'
          okText='Save'
          isSubmitDisabled={isCreateMediaLoading}
          searchTag={newFolderTagSearchKey}
          onSearchTags={searchKey => {
            setNewFolderTagSearchKey(searchKey)
          }}
          filterType='ContentBank'
          contentName='TAGS'
          module='CONTENT_BANK'
          project={project}
        />
      }

      {
        enableFolderActions &&
        <>
          {/* Edit folder modal */}
          <EditFolderModal
            visible={isEditFolderModelOpen}
            editFolderInfo={[editFolderInfo]}
            handleSubmit={input => {
              // if (isEmpty(input.name) || isEmpty(input?.tags)) return
              console.log('editFolderInfo', editFolderInfo)
              updateFolder({
                variables: {
                  name: input.name,
                  type: rootFolderDetails?.id,
                  tags: input.tags,
                  project,
                  id: editFolderInfo?.id
                },
                onCompleted: () => {
                  message.success(userMessages.FOLDER_EDIT_SUCCESS)
                  setTimeout(() => {
                    fetchMoreFolders({
                      variables: {
                        offset: innerFolderList.length
                      },
                      updateQuery: (previousData, { fetchMoreResult }) => {
                        const previousFolderItems = previousData?.listFolders?.items || []
                        const newFolderItems = fetchMoreResult.listFolders.items
                        const uniqueItems = uniqBy(flatten([previousFolderItems, newFolderItems]), 'name')
                        return {
                          ...previousData,
                          listFolders: {
                            ...(previousData?.listFolders || []),
                            items: uniqueItems
                          }
                        }
                      }
                    }, 1500)
                  })
                  setEditFolderModalOpen(false)
                },
                onError: (error) => {
                  utilityService.handleError(error)
                }
              })
            }}
            handleCancel={() => {
              setEditFolderModalOpen(false)
              setEditFolderInfo(null)
            }}
            loading={isUpdateFolderLoading}
            title='EDIT FOLDER'
            okText='Save'
            isSubmitDisabled={isUpdateFolderLoading}
            searchTag={newFolderTagSearchKey}
            onSearchTags={searchKey => {
              setNewFolderTagSearchKey(searchKey)
            }}
            filterType='ContentBank'
            contentName='TAGS'
            module='CONTENT_BANK'
            project={project}
          />
          {/* Delete folder modal */}
          <DeleteFolderModal
            isVisible={isDeleteFolderModalOpen}
            deleteItems={deleteFolderItem ? [deleteFolderItem] : null}
            handleSubmit={() => {
              deleteFolder({
                variables: {
                  project,
                  id: [deleteFolderItem?.id]
                },
                onCompleted: () => {
                  message.success(userMessages.FOLDER_DELETE_SUCCESS)
                  setDeleteFolderItem(null)
                  setIsDeleteFolderModalOpen(false)
                },
                onError: (error) => {
                  utilityService.handleError(error)
                },
                update: (cache, deletedFolderDetails) => {
                  const folderToRemove = deletedFolderDetails?.data?.deleteFolders?.[0]
                  let existingData = cloneDeep(
                    cache.readQuery({
                      query: QueryListFolders,
                      variables: useListFoldersVariables
                    })
                  )
                  const folderRemovedData = existingData?.listFolders?.items?.filter(folderItem => folderItem.id !== folderToRemove)
                  existingData.listFolders.items = folderRemovedData
                  // existingData.data
                  cache.writeQuery({
                    query: QueryListFolders,
                    variables: useListFoldersVariables,
                    data: existingData
                  })
                }
              })
            }}
            handleCancel={() => {
              setIsDeleteFolderModalOpen(false)
              setDeleteFolderItem(null)
            }}
            isLoading={isDeleteFolderLoading}
            title={'DELETE FOLDER'}
            message1={'Are you sure you want to delete this folder?'}
            message2={'This action cannot be undone.'}
            okText={'Delete'}
          />
        </>
      }
    </>
  )
}

export default FilesContent
